import { render, staticRenderFns } from "./Schemes.vue?vue&type=template&id=db37ae0a&scoped=true&"
import script from "./Schemes.vue?vue&type=script&lang=js&"
export * from "./Schemes.vue?vue&type=script&lang=js&"
import style0 from "./Schemes.vue?vue&type=style&index=0&id=db37ae0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db37ae0a",
  null
  
)

export default component.exports